import { createAppLocalStorage } from './localStorage';

export const [getLocalStorage, setLocalStorage, makeLocalStorageKey] = createAppLocalStorage({ prefix: 'time' });
